module.exports = __webpack_public_path__ + "static/media/check-16px.14eccd39.svg";